import { OverlayModule } from '@angular/cdk/overlay';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { NgSelectModule } from '@ng-select/ng-select';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgIconModule } from '@app/src/app/icon';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { CalendarModule } from '@shared/components/calendar';
import { ArrayPipesModule } from '@shared/pipes';
import { SlugifyPipeModule } from '@shared/pipes/slugify/slugify-pipe.module';

import { BottomSheetModule } from '../bottom-sheet';
import { GenericModule } from '../generic';
import { TextModule } from '../text/text.module';
import { TooltipModule } from '../tooltip';
import { FormCheckboxComponent } from './components/form-checkbox/form-checkbox.component';
import { FormDateRangeComponent } from './components/form-date-range/form-date-range.component';
import { FormDateRangeModule } from './components/form-date-range/form-date-range.module';
import { FormDateComponent } from './components/form-date/form-date.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { FormGroupedSelectComponent } from './components/form-grouped-select/form-grouped-select.component';
import { FormMultiDateComponent } from './components/form-multi-date/form-multi-date.component';
import { FormSelectOptionComponent } from './components/form-select/form-select-option/form-select-option.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { FormSheetGroupedSelectComponent } from './components/form-sheet-grouped-select/form-sheet-grouped-select.component';
import { FormSheetSelectComponent } from './components/form-sheet-select';
import { FormTextInputComponent } from './components/form-text-input/form-text-input.component';
import { FormToggleComponent } from './components/form-toggle/form-toggle.component';
import { MgFormFileComponent } from './components/mg-form-file';
import {
  MingaPartnerSearchDirective,
  MingaSearchDirective,
  MingaSwitcherDirective,
  OutputValueOnlyDirective,
  TeacherSearchDirective,
} from './directives';
import { MakeInputErrorMessagePipe } from './pipes';
import { FormTextAreaPreviewPipe } from './pipes/form-textarea-preview.pipe';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    MgSpinnerModule,
    CalendarModule,
    TooltipModule,
    GenericModule,
    FormDateRangeModule,
    SlugifyPipeModule,
    BottomSheetModule,
    MgEmptyStateModule,

    // External dependencies
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CdkScrollableModule,
    ScrollingModule,
    NgSelectModule,
    MatSlideToggleModule,
    OverlayModule,
    TextModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatRadioModule,
    ArrayPipesModule,
  ],
  exports: [
    // Directives
    MingaSwitcherDirective,
    MingaPartnerSearchDirective,
    MingaSearchDirective,
    OutputValueOnlyDirective,
    TeacherSearchDirective,

    // Components
    FormSelectComponent,
    FormTextInputComponent,
    FormToggleComponent,
    FormErrorComponent,
    FormCheckboxComponent,
    FormMultiDateComponent,
    FormSelectOptionComponent,
    FormDateComponent,
    FormDateRangeComponent,
    FormGroupedSelectComponent,
    FormSheetSelectComponent,
    FormSheetGroupedSelectComponent,
    MgFormFileComponent,
    // Pipes
    MakeInputErrorMessagePipe,
  ],
  declarations: [
    // Pipes
    MakeInputErrorMessagePipe,
    FormTextAreaPreviewPipe,

    // Directives
    MingaSwitcherDirective,
    MingaSearchDirective,
    MingaPartnerSearchDirective,
    OutputValueOnlyDirective,
    TeacherSearchDirective,

    // Components
    FormTextInputComponent,
    FormSelectComponent,
    FormToggleComponent,
    FormErrorComponent,
    FormCheckboxComponent,
    FormMultiDateComponent,
    FormSelectOptionComponent,
    FormDateComponent,
    FormGroupedSelectComponent,
    FormSheetSelectComponent,
    FormSheetGroupedSelectComponent,
    MgFormFileComponent,
  ],
})
export class FormModule {}
